import { Card } from "@/components/ui/card";
import { SectionCards } from "./section-cards";
import { UsersChart } from "./users-chart";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";
import { Badge } from "@/components/ui/badge";
import { Download } from "lucide-react";
import MonthlyRevenueChartWithData from "./monthly-revenue-chart-with-data";
import RevenueByPlanChartWithData from "./revenue-by-plan-chart-with-data";

const invoices = [
    {
        id: "8FB28438-0001",
        customer: "Robert Baratheon",
        status: "Paid",
        statusColor: "bg-green-200 text-green-800",
        date: "5/30/14",
        dueDate: "7/11/19",
        amount: "$928.41",
    },
    {
        id: "ECF17C97-0017",
        customer: "Arlene McCoy",
        status: "Overdue by 1 day",
        statusColor: "bg-red-200 text-red-800",
        date: "6/21/19",
        dueDate: "9/23/16",
        amount: "$396.84",
    },
    {
        id: "FA083B17-0017",
        customer: "Devon Lane",
        status: "Due in 14 days",
        statusColor: "bg-blue-200 text-blue-800",
        date: "7/11/19",
        dueDate: "3/4/16",
        amount: "$490.51",
    },
    {
        id: "FA083B17-0017",
        customer: "Ronald Richards",
        status: "Partially Paid",
        statusColor: "bg-emerald-200 text-emerald-800",
        date: "4/21/12",
        dueDate: "5/27/15",
        amount: "$601.13",
    },
];

const AdminReports = () => {
    return (
        <div className="flex flex-1 flex-col">
            <div className="@container/main flex flex-1 flex-col gap-2">
                <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6">
                    <SectionCards />
                    <div>
                        <UsersChart />
                    </div>
                    <div className="grid grid-cols-1 gap-4 md:gap-6 *:data-[slot=card]:from-primary/5 *:data-[slot=card]:to-card dark:*:data-[slot=card]:bg-card *:data-[slot=card]:bg-gradient-to-t *:data-[slot=card]:shadow-xs @xl/main:grid-cols-2">
                        <MonthlyRevenueChartWithData />
                        <RevenueByPlanChartWithData />
                    </div>
                    <Card className="w-full mx-auto p-4">
                        <div className="flex justify-end items-center mb-4">
                            <Button className="bg-blue-600 hover:bg-blue-700 text-white">
                                <Download /> Export
                            </Button>
                        </div>

                        <Table>
                            <TableHeader>
                                <TableRow>
                                    <TableHead>
                                        <Checkbox />
                                    </TableHead>
                                    <TableHead>Invoice Number</TableHead>
                                    <TableHead>Customer Name</TableHead>
                                    <TableHead>Status</TableHead>
                                    <TableHead>Date</TableHead>
                                    <TableHead>Due Date</TableHead>
                                    <TableHead>Amount</TableHead>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {invoices.map((invoice) => (
                                    <TableRow key={invoice.id} className="hover:bg-muted/20">
                                        <TableCell>
                                            <Checkbox />
                                        </TableCell>
                                        <TableCell className="text-blue-600 font-medium">{invoice.id}</TableCell>
                                        <TableCell>{invoice.customer}</TableCell>
                                        <TableCell>
                                            <Badge className={invoice.statusColor}>{invoice.status}</Badge>
                                        </TableCell>
                                        <TableCell>{invoice.date}</TableCell>
                                        <TableCell>{invoice.dueDate}</TableCell>
                                        <TableCell className="font-medium">{invoice.amount}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default AdminReports;
